import loglevel from "loglevel";

export default loglevel.getLogger("solana-embed");
